import React from "react";
import Markdown from "marked-react";
import "./markdownStyles.css";
import { normalizeQuotes } from "../../utils/normalizeQuotes";

interface MarkdownWrapperProps {
  content: string;
  className?: string;
}

/**
 * A wrapper component for marked-react Markdown that applies consistent styling
 * Ensures proper list styling with bullets and proper indentation
 */
const MarkdownWrapper: React.FC<MarkdownWrapperProps> = ({
  content,
  className = ""
}) => {
  if (!content) {
    return null;
  }

  // Ensure content is a string (defensive coding for malformed data)
  let contentString: string;
  if (typeof content !== 'string') {
    console.warn('[MarkdownWrapper] Received non-string content:', content);
    // Try to extract string from object or stringify it
    if (typeof content === 'object') {
      contentString = JSON.stringify(content);
    } else {
      contentString = String(content);
    }
  } else {
    contentString = content;
  }

  // Preprocess to normalize bullets like "• item • item" or lines starting with "• "
  let processedContent = contentString;
  // Convert start-of-line bullets "• " to Markdown list "- "
  processedContent = processedContent.replace(/(^|\n)\s*•\s+/g, "$1- ");
  // Convert inline separators " • " into new list items
  processedContent = processedContent.replace(/\s+•\s+/g, "\n- ");
  // Convert *[phrase]* to **phrase** (authors sometimes use this to mean bold)
  processedContent = processedContent.replace(/\*\[([^\]]+)\]\*/g, "**$1**");
  // Normalise quotes using the shared utility (same logic as CardWrapper data layer).
  processedContent = normalizeQuotes(processedContent);

  return (
    <div className={`markdown-wrapper ${className}`}>
      <Markdown gfm breaks>{processedContent}</Markdown>
    </div>
  );
};

export default MarkdownWrapper; 